/**
 * Authentication configuration for Cognito OAuth
 * Reads configuration from environment variables (Vite: VITE_*)
 */

const DEV_API_BASE_URL = 'https://1vz8lzl9b9.execute-api.us-east-1.amazonaws.com/api-dev-stage';
const DEV_COGNITO_DOMAIN = 'auth.dev.portcierge.com';
const DEV_COGNITO_CLIENT_ID = '264p3prtl7q631puc7pf86tjja';

// Get Cognito domain from environment (e.g., auth.dev.portcierge.com)
export const cognitoDomain: string = import.meta.env.VITE_COGNITO_DOMAIN || DEV_COGNITO_DOMAIN;

// Get web client ID from environment
export const clientId: string = import.meta.env.VITE_COGNITO_CLIENT_ID || DEV_COGNITO_CLIENT_ID;

// Get API base URL from environment
export const apiBaseUrl: string = import.meta.env.VITE_API_BASE_URL || DEV_API_BASE_URL;

// Auto-detect redirect URI from current location
export const getRedirectUri = (): string => {
  if (import.meta.env.VITE_REDIRECT_URI) {
    return import.meta.env.VITE_REDIRECT_URI;
  }
  // Auto-detect from window.location
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    return `${origin}/callback`;
  }
  return 'http://localhost:3000/callback';
};

// OAuth scopes
export const scopes: string = [
  'email',
  'openid',
  'profile',
  'https://api.wanderertrip.com/access'
].join(' ');

// Cognito endpoints
export interface CognitoEndpoints {
  authorize: string;
  token: string;
  logout: string;
  userInfo: string;
}

export const getCognitoEndpoints = (): CognitoEndpoints => {
  if (!cognitoDomain) {
    throw new Error('VITE_COGNITO_DOMAIN is not configured');
  }
  
  const baseUrl = `https://${cognitoDomain}`;
  return {
    authorize: `${baseUrl}/authorize`,
    token: `${baseUrl}/oauth2/token`,
    logout: `${baseUrl}/logout`,
    userInfo: `${baseUrl}/oauth2/userInfo`
  };
};

// Validate configuration
export const validateConfig = (): boolean => {
  const errors: string[] = [];
  
  if (!cognitoDomain) {
    errors.push('VITE_COGNITO_DOMAIN is required');
  }
  
  if (!clientId) {
    errors.push('VITE_COGNITO_CLIENT_ID is required');
  }
  
  if (!apiBaseUrl) {
    errors.push('VITE_API_BASE_URL is required');
  }
  
  if (errors.length > 0) {
    console.warn('Auth configuration errors:', errors);
  }
  
  return errors.length === 0;
};
